import * as type from './types';
import axios from '../../../common/config/axios';

export const getList = (data) => dispatch => {
    axios.get('financial_report/list', {params: data})
    .then((response) => {
        dispatch({
            type: type.LIST,
            payload: response.data
        });
    }).catch(err => {
        // console.warn(err);
    });
};